// 应急保障 相关请求
import req from './index'


//获取应急保障列表
export const getEmergencListAPI = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.EmergencList_Get', params)
}

//删除应急保障图片
export const delEmergencListAPI = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.EmergencSet', params)
}